import * as THREE from 'three';

export class boundary {
    public min: THREE.Vector2;
    public max: THREE.Vector2;

    constructor(points: THREE.Vector2[]) {
        this.min = new THREE.Vector2(Number.MAX_VALUE, Number.MAX_VALUE);
        this.max = new THREE.Vector2(-Number.MAX_VALUE, -Number.MAX_VALUE);

        for (let i = 0; i < points.length; i++) {
            this.min.min(points[i]);
            this.max.max(points[i]);
        }
    }
}
